import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import $ from 'jquery';
import {number_input_format} from '../helper/format';
import {
  isMobile
} from "react-device-detect";

export default class Postdiscountcardpopup extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            open: false,
            selectedCard: null,
            cardlist: []
        }
    }
    Open(_selectedCard)
    {
        this.requestData();
        this.setState({
            selectedCard: _selectedCard,
            open: true
        });
    }
    requestData()
    {
        const self = this;
        $.post('https://api.tfamily.co.kr/api/mobile/base',{},function(data){
            let parsedData = JSON.parse(data), cards, displaylist = [];
            cards = parsedData.data.card;

            let emptyCard = {
                name: "미적용",
                discount_min: 0,
                display_selected_card: false
            }

            if(self.state.selectedCard == null)
            {
                emptyCard.display_selected_card = true;
            }

            displaylist.push(emptyCard);

            for (let i = 0 ; i < cards.length ; i++)
            {
                let card = cards[i];

                if(self.state.selectedCard && self.state.selectedCard.idx === card.idx)
                {
                    cards[i].display_selected_card = true;
                }

                if( card.part == "C" )
                {
                    displaylist.push(card);
                }
            }
            self.setState({
                cardlist: displaylist
            });
        });
    }
    Close()
    {
        this.setState({
            open: false
        });
    }
    CardSelect(card)
    {
        this.props.onCardChanged(card, false);
    }
    render()
    {
        const self = this;
        return(
            <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
                <div className="modal-dialog modal-lg mb0">
                    <div className={(isMobile)? 'popupPaddding3' : 'popupPadding pr45'}>
                        <div className="md-popup-header"> &nbsp;청구할인카드</div>
                        <div className="row pl15 pr15 scroll400">
                            <table className="table priceTable">
                                    <tbody className="scroll-tbody-y-card">
                                    {
                                        self.state.cardlist.map((card, index)=>{
                                            return (
                                                <tr key={index} className={(card.display_selected_card) ? 'priceSelect' : ''} onClick={()=>self.CardSelect(card)}>
                                                    <td><b>{card.name}</b></td>
                                                    <td className="width80 text-center">{
                                                        (card.pay==2) ? <label className="label label-danger">이체</label>: ''
                                                    }</td>
                                                    <td>월 {number_input_format(card.discount_min)} ~ </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}
